import React from "react";
import "./TVTokenTable.css";
import { Table, Popconfirm, Button, message } from "antd";
import { useSelector } from "react-redux";
import { CopyOutlined } from "@ant-design/icons";
import lang from "../../../../services/lang";
import { USER_SITE } from "../../../../services/common/urls";

function TVTokenTable(props) {
  const { langIndex } = useSelector((x) => x.app);
  const { tokenList, deleteToken, onClickEditRecord, selCustomerId } = props;

  const copyToClipboard = (text) => {
    navigator.clipboard.writeText(text).then(
      () => {
        message.success(lang(langIndex, "tv_token_url_copied"));
      },
      () => {
        message.error(lang(langIndex, "msg_something_wrong"));
      }
    );
  };

  const getDashboardTypeLabel = (dashboardType) => {
    switch (dashboardType) {
      case "cnc":
        return lang(langIndex, "tv_token_dashboard_cnc");
      case "custom_dashboard":
        return lang(langIndex, "tv_token_dashboard_custom");
      case "utilization":
        return lang(langIndex, "tv_token_dashboard_utilization");
      case "machine_detail":
        return lang(langIndex, "tv_token_dashboard_machine_detail") + " (CNC)";
      case "machine_detail_utilization":
        return lang(langIndex, "tv_token_dashboard_machine_detail") + " (Utilization)";
      case "machine_schedule":
        return lang(langIndex, "tv_token_dashboard_machine_schedule");
      case "tms":
        return lang(langIndex, "tv_token_dashboard_tms");
      case "tms_alarm":
        return lang(langIndex, "tv_token_dashboard_tms_alarm");
      case "sensor":
        return lang(langIndex, "tv_token_dashboard_sensor");
      case "maintenance":
        return lang(langIndex, "tv_token_dashboard_maintenance");
      case "report":
        return lang(langIndex, "tv_token_dashboard_report");
      case "job_entry":
        return lang(langIndex, "tv_token_dashboard_job_entry");
      default:
        return dashboardType;
    }
  };

  const buildTokenUrl = (token) => {
    const baseUrl = window.location.origin;
    return `${baseUrl}${USER_SITE}/tv/${token}`;
  };

  const columns = [
    {
      title: lang(langIndex, "tv_token_name"),
      dataIndex: "token_name",
      key: "token_name",
    },
    {
      title: lang(langIndex, "tv_token_dashboard_type"),
      dataIndex: "dashboard_type",
      key: "dashboard_type",
      render: (dashboard_type) => {
        return getDashboardTypeLabel(dashboard_type);
      },
    },
    {
      title: lang(langIndex, "tv_token_dashboard_id"),
      dataIndex: "dashboard_id",
      key: "dashboard_id",
      render: (dashboard_id) => {
        return dashboard_id || "-";
      },
    },
    {
      title: lang(langIndex, "tv_token_url"),
      dataIndex: "token",
      key: "token",
      render: (token) => {
        const url = buildTokenUrl(token);
        return (
          <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
            <span
              style={{
                maxWidth: "300px",
                overflow: "hidden",
                textOverflow: "ellipsis",
                whiteSpace: "nowrap",
              }}
            >
              {url}
            </span>
            <Button
              type="link"
              size="small"
              icon={<CopyOutlined />}
              onClick={() => copyToClipboard(url)}
              style={{ padding: 0, minWidth: "auto" }}
            />
          </div>
        );
      },
    },
    {
      title: lang(langIndex, "jobentry_operation"),
      dataIndex: "operation",
      render: (_, record) => {
        return (
          <div>
            <a onClick={() => editRecord(record)}>
              {lang(langIndex, "jobentry_edit")}
            </a>
            <Popconfirm
              title={lang(langIndex, "jobentry_suretodelete")}
              onConfirm={() => deleteRecord(record)}
            >
              <a style={{ marginLeft: 10, color: "red" }}>
                {lang(langIndex, "jobentry_delete")}
              </a>
            </Popconfirm>
          </div>
        );
      },
    },
  ];

  const editRecord = (record) => {
    onClickEditRecord(record);
  };

  const deleteRecord = (record) => {
    deleteToken(record.id);
  };

  return (
    <div>
      <Table
        className="user-table-style"
        dataSource={tokenList}
        columns={columns}
        pagination={{ pageSize: 5 }}
      />
    </div>
  );
}

export default TVTokenTable;

